function getFocusableElements(container) {
  if (!container) return []

  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

class ProductCardSlider extends HTMLElement {
  constructor() {
    super()
    this.slide = this.querySelector('.simple-card__splide-wrapper')

    this.initSplide()
  }

  initSplide() {
    if (!this.slide) return;

    const count = this.slide.getAttribute('data-media-count')

    if (count === '1') return false

    var splide = new Splide(this.slide, {
      speed: 500,
      dragMinThreshold: 20,
      snap: true,
      gap: 0,
      pagination: true,
      arrows: false,
      mediaQuery: 'min',
      breakpoints: {
        767: {
          destroy: true
        }
      }
    })

    splide.mount()
  }
}

customElements.define('product-card-slider', ProductCardSlider)

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  const detailsEl = summary.parentElement

  if (detailsEl?.classList.contains('js-details-native-disclosure')) {
    if (!summary.closest('header-drawer, menu-drawer')) {
      detailsEl.addEventListener('keyup', onKeyUpEscape)
    }

    return
  }

  summary.setAttribute('role', 'button')

  if (summary.matches('.js-menu-drawer-summary')) return

  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'))

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
  })

  if (summary.closest('header-drawer, menu-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const menuItemsHasSubmenuEls = Array.from(document.querySelectorAll('[data-menu-item-has-submenu]'))
menuItemsHasSubmenuEls.forEach(menuItemEl =>  {
  const detailsEl = menuItemEl.querySelector('details')
  const summaryEl = menuItemEl.querySelector('summary')

  if (detailsEl && summaryEl) {
    menuItemEl.addEventListener('mouseover', () => {
      detailsEl.setAttribute('open', 'true')
      summaryEl.setAttribute('aria-expanded', 'true')
    });

    menuItemEl.addEventListener('mouseleave', () => {
      detailsEl.removeAttribute('open')
      summaryEl.setAttribute('aria-expanded', 'false')
    });
  }
});

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()

  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length)
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch (e) {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', (event) => {
    mouseClick = true
  })

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused')

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add('focused')
    },
    true
  )
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => video.pause())
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')

  if (!openDetailsElement.classList.contains('js-details-native-disclosure')) {
    summaryElement.setAttribute('aria-expanded', false)
  }

  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.input.addEventListener('change', this.onInputChange.bind(this))
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)))
  }

  quantityUpdateUnsubscriber = undefined

  connectedCallback() {
    this.validateQtyRules()
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber()
    }
  }

  onInputChange(event) {
    this.validateQtyRules()
  }

  onButtonClick(event) {
    event.preventDefault()
    const button = event.currentTarget

    if (button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') {
      return
    }

    const previousValue = this.input.value

    button.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
  }

  validateQtyRules() {
    const value = parseInt(this.input.value)
    if (this.input.min) {
      const min = parseInt(this.input.min)
      const buttonMinus = this.querySelector(".quantity__button[name='minus']")
      const isDisabled = value <= min
      buttonMinus.classList.toggle('disabled', isDisabled)
      buttonMinus.toggleAttribute('disabled', isDisabled)
      buttonMinus.setAttribute('aria-disabled', isDisabled ? 'true' : 'false')
      if (isDisabled) {
        buttonMinus.setAttribute('tabindex', '-1')
      } else {
        buttonMinus.removeAttribute('tabindex')
      }
    }
    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = this.querySelector(".quantity__button[name='plus']")
      const isDisabled = value >= max
      buttonPlus.classList.toggle('disabled', isDisabled)
      buttonPlus.toggleAttribute('disabled', isDisabled)
      buttonPlus.setAttribute('aria-disabled', isDisabled ? 'true' : 'false')
      if (isDisabled) {
        buttonPlus.setAttribute('tabindex', '-1')
      } else {
        buttonPlus.removeAttribute('tabindex')
      }
    }
  }
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` }
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid)

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  }
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector('details')

    this.onSummaryClick = this.onSummaryClick.bind(this)
    this.onCloseButtonClick = this.onCloseButtonClick.bind(this)
    this.onKeyUp = this.onKeyUp.bind(this)
    this.onFocusOut = this.onFocusOut.bind(this)

    this.addEventListener('keyup', this.onKeyUp)
    this.addEventListener('focusout', this.onFocusOut)
    this.bindEvents()
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => {
      summary.removeEventListener('click', this.onSummaryClick)
      summary.addEventListener('click', this.onSummaryClick)
    })
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) => {
      button.removeEventListener('click', this.onCloseButtonClick)
      button.addEventListener('click', this.onCloseButtonClick)
    })
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement)
  }

  getMenuRoot() {
    return this.mainDetailsToggle || this
  }

  resetNestedMenus() {
    const root = this.getMenuRoot()
    root.querySelectorAll('details.first-level').forEach((details) => {
      details.removeAttribute('open')
      details.classList.remove('menu-opening')
    })
    root.querySelectorAll('.submenu-open').forEach((el) => el.classList.remove('submenu-open'))
  }

  openSubMenus(scope = this) {
    const root = scope instanceof Element ? scope : this
    root.querySelectorAll('details.second-level').forEach((details) => {
      details.setAttribute('open', '')
      details.classList.add('menu-opening')
      details.querySelector('summary')?.setAttribute('aria-expanded', 'true')
    })
  }

  onSubmenuSummaryClick(detailsElement, summaryElement, parentMenuElement) {
    const isOpen = detailsElement.hasAttribute('open')

    detailsElement.classList.toggle('menu-opening', isOpen)
    parentMenuElement?.classList.toggle('submenu-open', isOpen)
    summaryElement.setAttribute('aria-expanded', String(isOpen))

    if (!isOpen) return

    if (detailsElement.classList.contains('first-level')) {
      this.openSubMenus(detailsElement)
    }

    if (this.matches('header-drawer')) return

    const panel = summaryElement.nextElementSibling
    if (!panel) return

    const closeButton = detailsElement.querySelector('button')
    const addTrapFocus = () => {
      trapFocus(panel, closeButton)
      panel.removeEventListener('transitionend', addTrapFocus)
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      addTrapFocus()
    } else {
      panel.addEventListener('transitionend', addTrapFocus)
    }
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const parentMenuElement = detailsElement.closest('.has-submenu')
    const isOpen = detailsElement.hasAttribute('open')

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement)

      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
      }
      return
    }

    setTimeout(
      () => this.onSubmenuSummaryClick(detailsElement, summaryElement, parentMenuElement),
      100
    )
  }

  openMenuDrawer(summaryElement) {
    if (!this.mainDetailsToggle) return

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return
    if (!this.mainDetailsToggle) return

    this.mainDetailsToggle.classList.remove('menu-opening')
    this.resetNestedMenus()
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
    removeTrapFocus(elementToFocus)
    this.closeAnimation(this.mainDetailsToggle)

    if (event instanceof KeyboardEvent && elementToFocus && !elementToFocus.matches('.js-menu-drawer-summary')) {
      elementToFocus.setAttribute('aria-expanded', false)
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle?.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer()
    })
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details')

    if (detailsElement) this.closeSubmenu(detailsElement)
    if (!event.currentTarget.matches('.js-close-dialog')) return

    document.body.classList.remove('overflow-hidden')
  }

  closeSubmenu(detailsElement) {
    if (!detailsElement) return

    detailsElement.closest('.submenu-open')?.classList.remove('submenu-open')
    detailsElement.classList.remove('menu-opening')

    const summaryEl = detailsElement.querySelector('summary')
    if (summaryEl && !summaryEl.matches('.js-menu-drawer-summary')) {
      summaryEl.setAttribute('aria-expanded', 'false')
    }

    removeTrapFocus(summaryEl)
    this.closeAnimation(detailsElement)
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'))
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()

    this.menuSummaryButton = this.querySelector('.js-menu-drawer-summary')
    this.mainDetailsToggle = this.querySelector('.menu-drawer-container')
    this.overlay = this.querySelector('.js-overlay')
    this.dialog = this.querySelector('.js-dialog')
    this.closeDialogButton = this.querySelector('.js-close-dialog')

    this.onMenuSummaryClick = this.onMenuSummaryClick.bind(this)
    this.onOverlayClick = this.onOverlayClick.bind(this)
  }

  connectedCallback() {
    if (this.isConnectedBound) return
    this.isConnectedBound = true

    this.menuSummaryButton?.addEventListener('click', this.onMenuSummaryClick)
    this.overlay?.addEventListener('click', this.onOverlayClick)
  }

  disconnectedCallback() {
    this.menuSummaryButton?.removeEventListener('click', this.onMenuSummaryClick)
    this.overlay?.removeEventListener('click', this.onOverlayClick)
    window.removeEventListener('resize', this.onResize)
  }

  onMenuSummaryClick(event) {
    event.preventDefault()

    if (!this.mainDetailsToggle || !this.menuSummaryButton) return

    const isOpen = this.mainDetailsToggle.hasAttribute('open')
    isOpen ? this.closeMenuDrawer(event, this.menuSummaryButton) : this.openMenuDrawer(this.menuSummaryButton)

    if (window.matchMedia('(max-width: 990px)').matches) {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
    }
  }

  onOverlayClick() {
    this.closeMenuDrawer(undefined, this.menuSummaryButton)
  }

  openMenuDrawer(summaryElement) {
    if (!this.mainDetailsToggle) return

    this.header = this.header || document.querySelector('.section-header')
    this.borderOffset = this.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0
    const headerBottomPosition = this.header ? this.header.getBoundingClientRect().bottom - this.borderOffset : 0
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(headerBottomPosition, 10)}px`
    )
    this.header?.classList.add('menu-open')
    this.mainDetailsToggle.setAttribute('open', '')

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })

    window.addEventListener('resize', this.onResize)
    document.body.classList.add('overflow-hidden')
    if (this.dataset.breakpoint) {
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }

    this.getMenuRoot()
      .querySelectorAll('details.first-level[open]')
      .forEach((details) => this.openSubMenus(details))

    if (this.dialog) {
      trapFocus(this.dialog, this.closeDialogButton || this.dialog)

      setTimeout(() => {
        this.closeDialogButton?.focus()
      }, 250)
    }
  }

  closeMenuDrawer(event, elementToFocus = this.menuSummaryButton) {
    if (!this.mainDetailsToggle) return

    this.mainDetailsToggle.classList.remove('menu-opening')
    this.resetNestedMenus()

    this.closeAnimation(this.mainDetailsToggle)
    this.header?.classList.remove('menu-open')
    window.removeEventListener('resize', this.onResize)
    document.body.classList.remove('overflow-hidden')
    if (this.dataset.breakpoint) {
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
    }

    removeTrapFocus(elementToFocus)
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openSubmenu =
      event.target.closest('details.second-level[open]') ||
      event.target.closest('details.first-level[open]')

    if (openSubmenu) {
      this.closeSubmenu(openSubmenu)
      return
    }

    if (this.mainDetailsToggle?.hasAttribute('open')) {
      this.closeMenuDrawer(event, this.menuSummaryButton)
    }
  }

  onCloseButtonClick(event) {
    if (event.currentTarget.matches('.js-close-dialog')) {
      this.closeMenuDrawer(event, this.menuSummaryButton)
      return
    }

    const detailsElement = event.currentTarget.closest('details')
    if (!detailsElement) return
    this.closeSubmenu(detailsElement)
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset, 10)}px`
      )
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
  }
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false))
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide()
      })
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide()
      })
    }
  }

  connectedCallback() {
    if (this.moved) return
    this.moved = true
    document.body.appendChild(this)
  }

  show(opener) {
    this.openedBy = opener
    const popup = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    document.body.dispatchEvent(new CustomEvent('modalClosed'))
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector('button')

    if (!button) return
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'))
      if (modal) modal.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')

    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  connectedCallback() {
    if (this.dataset.autoplay === 'true') {
      this.loadContent(false, true)
    }
  }

  loadContent(focus = true, autoplay = false) {
    if (!autoplay) {
      window.pauseAllMedia()
    }
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

      this.setAttribute('loaded', true)
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'))
      if (focus) deferredElement.focus()
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.hasAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play()
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class SliderComponent extends HTMLElement {
  constructor() {
    super()
    this.slider = this.querySelector('[id^="Slider-"]')
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.enableSliderLooping = false
    this.currentPageElement = this.querySelector('.slider-counter--current')
    this.pageTotalElement = this.querySelector('.slider-counter--total')
    this.prevButton = this.querySelector('button[name="previous"]')
    this.nextButton = this.querySelector('button[name="next"]')

    if (!this.slider || !this.nextButton) return

    this.initPages()

    const resizeObserver = new ResizeObserver(debounce(this.resetPages.bind(this), 500))
    resizeObserver.observe(this.slider)

    this.slider.addEventListener('scroll', this.update.bind(this))
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this))
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this))

    if (this.tagName === 'SLIDER-COMPONENT') {
      this.hideNonVisibleSlides = this.hideNonVisibleSlides.bind(this)
      this.hideNonVisibleSlides();
      this.slider.addEventListener('scrollend', this.hideNonVisibleSlides)
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0)
    if (this.sliderItemsToShow.length < 2) return
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset)
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1
    this.update()
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.initPages()
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return

    const previousPage = this.currentPage
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage
      this.pageTotalElement.textContent = this.totalPages
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        })
      )
    }

    if (this.enableSliderLooping) return

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled')
    } else {
      this.prevButton.removeAttribute('disabled')
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled')
    } else {
      this.nextButton.removeAttribute('disabled')
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + Math.floor(this.slider.scrollLeft) - offset
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= Math.floor(this.slider.scrollLeft)
  }

  onButtonClick(event) {
    event.preventDefault()
    const step = event.currentTarget.dataset.step || 1
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset
    this.slider.scrollTo({
      left: this.slideScrollPosition
    })
  }

  hideNonVisibleSlides() {
    this.sliderItemsToShow.forEach(slide => {
      if (this.isSlideVisible(slide)) {
        const focusableEls = getFocusableElements(slide)

        focusableEls.forEach(el => {
          el.removeAttribute('tabindex')
        })
        slide.removeAttribute('aria-hidden')
      } else {
        const focusableEls = getFocusableElements(slide)

        focusableEls.forEach(el => {
          el.setAttribute('tabindex', '-1')
        })

        slide.setAttribute('aria-hidden', 'true')
      }
    })
  }
}

customElements.define('slider-component', SliderComponent)

class SlideshowComponent extends SliderComponent {
  constructor() {
    super()
    this.sliderControlWrapper = this.querySelector('.slider-buttons')
    this.enableSliderLooping = true

    if (!this.sliderControlWrapper) return

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide')
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'))
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)))
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this))
    this.setSlideVisibility()

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false

      this.desktopLayout = window.matchMedia('(min-width: 750px)')
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
      ;[this.reducedMotion, this.desktopLayout]
        .forEach((mediaQuery) => {
          mediaQuery.addEventListener('change', () => {
            if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay()
          })
        })
        [(this.prevButton, this.nextButton)].forEach((button) => {
          button.addEventListener(
            'click',
            () => {
              this.announcementBarArrowButtonWasClicked = true
            },
            { once: true }
          )
        })
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay()
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000
    this.addEventListener('mouseover', this.focusInHandling.bind(this))
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this))
    this.addEventListener('focusin', this.focusInHandling.bind(this))
    this.addEventListener('focusout', this.focusOutHandling.bind(this))

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay')
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this))
      this.autoplayButtonIsSetToPlay = true
      this.play()
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play()
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event)
    const isFirstSlide = this.currentPage === 1
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length

    if (!isFirstSlide && !isLastSlide) return

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    })
  }

  update() {
    super.update()
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link')
    this.prevButton.removeAttribute('disabled')

    if (!this.sliderControlButtons.length) return

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active')
      link.removeAttribute('aria-current')
    })
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active')
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true)
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay)
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play()
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target)
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return
      this.play()
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play()
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target)
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play()
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause()
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause()
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off')
    clearInterval(this.autoplay)
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite')
    clearInterval(this.autoplay)
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused')
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow)
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused')
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow)
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth
    this.slider.scrollTo({
      left: slideScrollPosition
    })
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a')
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex')
          })
        item.setAttribute('aria-hidden', 'false')
        item.removeAttribute('tabindex')
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1')
          })
        item.setAttribute('aria-hidden', 'true')
        item.setAttribute('tabindex', '-1')
      }
    })
  }

  linkToSlide(event) {
    event.preventDefault()
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage)
    this.slider.scrollTo({
      left: slideScrollPosition
    })
  }
}

customElements.define('slideshow-component', SlideshowComponent)

class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
    // Ensure inventory message is hidden on load until a variant is selected
    const inventoryStockDiv = document.querySelector('[data-product-stock][data-inventory-threshold]')
    if (inventoryStockDiv) {
      inventoryStockDiv.classList.add('hidden')
    }
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    // select variant to add requires this removed: this.toggleAddButton(true, '', false);
    this.updatePickupAvailability()
    this.removeErrorMessage()
    this.updateVariantStatuses()
    this.updateInventoryMessage()

    if (!this.currentVariant) {
      if (this.checkSelections(this) >= 2) {
        this.setUnavailable()
      } else {
        this.toggleAddButton(true, window.variantStrings.chooseOptions, false)
      }
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateShareUrl()
    }

    document.dispatchEvent(new CustomEvent('variant:changed', {
      detail: {
        options: this.options,
        optionNames: this.optionNames
      }
    }))
  }

  checkSelections(context) {
    const inputs = context.querySelectorAll('[type="radio"]')
    let count = 0
    inputs.forEach((input) => {
      if (input.checked) {
        count = count + 1
      }
    })
    return count
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    this.optionNames = Array.from(this.querySelectorAll('select'), (select) => select.getAttribute('data-option-name') || '');
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`)
    mediaGalleries.forEach((mediaGallery) => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true))

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`)
    if (!modalContent) return
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`)
    modalContent.prepend(newMediaModal)
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    const params = new URLSearchParams(window.location.search);
    params.set('variant', this.currentVariant.id);
    window.history.replaceState({}, '', `${this.dataset.url}?${params.toString()}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton || !shareButton.updateUrl) return
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(':checked')?.value === variant.option1)
    const inputWrappers = [...this.querySelectorAll('.product-form__input')]

    inputWrappers.forEach((option, index) => {
      if (index === 0) return

      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1]?.querySelector(':checked')?.value
      if (!previousOptionSelected) return

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`])

      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    })
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value')
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'))
      }
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage() {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    productForm?.handleErrorMessage?.()
  }

  updateInventoryMessage() {
    if (!this.currentVariant) return

    const inventoryStockDiv = document.querySelector('[data-product-stock][data-inventory-threshold]')
    if (!inventoryStockDiv) return

    const threshold = parseInt(inventoryStockDiv.getAttribute('data-inventory-threshold'))
    const showInventoryLow = inventoryStockDiv.getAttribute('data-show-inventory-low') === 'true'
    const currentInventory = this.currentVariant.inventory_quantity

    if (showInventoryLow && currentInventory < threshold && currentInventory > 0) {
      // Show the message with updated count
      inventoryStockDiv.innerHTML = window.variantStrings.only_left.replace('[count]', currentInventory)
      inventoryStockDiv.classList.remove('hidden')
    } else {
      // Hide the message if conditions aren't met
      inventoryStockDiv.classList.add('hidden')
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`)
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`)
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`)

        if (source && destination) destination.innerHTML = source.innerHTML
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'))
        }

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove('visibility-hidden')

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '')

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`)
        const preorderEl = document.querySelector('product-preorder')

        // Hide before re-checking
        preorderEl.hide()

        const isPreorderAvailable = this.currentVariant.available && preorderEl.checkVariantPreorder(this.currentVariant.id)

        if (isPreorderAvailable) {
          // Do nothing, as the product-preorder component will handle it
        } else if (
          !this.currentVariant.available &&
          this.currentVariant.inventory_management === 'shopify' &&
          this.currentVariant.inventory_quantity <= 0
        ) {
          this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut)
        } else if (
          this.currentVariant.available &&
          this.currentVariant.inventory_management === 'shopify' &&
          this.currentVariant.inventory_quantity >= 1
        ) {
          const requireCustom = document.querySelector('[data-custom-rules]')?.getAttribute('data-custom-rules')
          if (requireCustom == 'true') {
            this.toggleAddButton(true, window.variantStrings.customizeFirst)
          } else {
            this.toggleAddButton(false, '', true)
          }
        } else if (this.currentVariant.available && this.currentVariant.inventory_management === null) {
          if (addButtonUpdated.hasAttribute('disabled')) {
            this.toggleAddButton(false, '', true)
          }
        } else {
          this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut)
        }

        if (isPreorderAvailable || this.currentVariant.available) {
          this.toggleBisButton(false)
        } else if (!this.currentVariant.available) {
          this.toggleBisButton(true)

          const variantID = this.currentVariant.id
          window.shopifyProduct.variants.forEach(function (variant) {
            if (variant.id !== variantID) return

            const isBisDisabledForVariant = variant.disable_back_in_stock === true || variant.bis_hidden === true
            this.toggleBisButton(!isBisDisabledForVariant)
          })
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant
          }
        })
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`)
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')

    if (!addButton) return
    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute('disabled')
      if (text) {
        addButtonText.textContent = text
      } else {
        addButtonText.textContent = window.variantStrings.addToCart
      }
    }

    addButton.classList.add('is-variant-selected')

    if (!modifyClass) return
  }

  toggleBisButton(show = true) {
    const bisButton = document.getElementById('BIS_button')
    const buttonWrapper = document.querySelector('.product-form__buttons')

    if (show) {
      bisButton?.classList.remove('hidden')
      buttonWrapper?.classList.add('bis-active')
    } else {
      bisButton?.classList.add('hidden')
      buttonWrapper?.classList.remove('bis-active')
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`)
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const price = document.getElementById(`price-${this.dataset.section}`)
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`)
    const sku = document.getElementById(`Sku-${this.dataset.section}`)

    if (addButton) {
      addButtonText.textContent = window.variantStrings.unavailable
      addButton.setAttribute('disabled', 'disabled')
    }
    if (price) price.classList.add('visibility-hidden')
    if (inventory) inventory.classList.add('visibility-hidden')
    if (sku) sku.classList.add('visibility-hidden')

    document.querySelector('product-preorder')?.hide()
    this.toggleBisButton(false)

    publish(PUB_SUB_EVENTS.variantUnavailable, null)
  }

  getVariantData() {
    const dataVariantsEl = this.querySelector('[data-variants][type="application/json"]')
    const dataInventoriesEl = this.querySelector('[data-inventories][type="application/json"]')
    const dataVariants = JSON.parse(dataVariantsEl?.textContent?.replaceAll('\n', '') ?? '[]')
    const dataInventories = JSON.parse(dataInventoriesEl?.textContent?.replaceAll('\n', '') ?? '{}')

    // Fix missing inventory_quantity in Liquid variant object on dev store
    const mergedData = dataVariants.map((variant) => {
      return {
        ...variant,
        inventory_quantity: dataInventories[variant.id] ?? 0
      }
    })

    this.variantData = mergedData

    return mergedData
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      // Require select must comment this code
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled')
      } else {
        input.classList.add('disabled')
      }
    })
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value
    })

    this.optionNames = fieldsets.map(fieldset => fieldset.getAttribute('data-option-name') || '')

    fieldsets.forEach((fieldset) => {
      const selected = this.options[fieldsets.indexOf(fieldset)]
      if (fieldset.querySelector('[data-selected-option]') && selected !== undefined) {
        var val = selected
        if (selected === 'XS') {
          val = 'Extra Small'
        } else if (selected === 'S' || selected === 'SM') {
          val = 'Small'
        } else if (selected === 'M' || selected === 'MD') {
          val = 'Medium'
        } else if (selected === 'L' || selected === 'LG') {
          val = 'Large'
        } else if (selected === 'XL') {
          val = 'Extra Large'
        } else if (selected === 'XXL') {
          val = 'Extra Extra Large'
        }

        fieldset.querySelector('[data-selected-option]').innerHTML = val
      }
    })
  }
}

customElements.define('variant-radios', VariantRadios)

class ProductRecommendations extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('product-recommendations')

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove()
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded')
          }
        })
        .catch((e) => {
          console.error(e)
        })
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this)
  }
}

customElements.define('product-recommendations', ProductRecommendations)

class CollectionHero extends HTMLElement {
  constructor() {
    super()

    // instance-scoped ids & attrs
    this.sectionId       = this.getAttribute('data-section-id')
    this.heroId          = `grid-collection-hero--${this.sectionId}` // <-- unique per section
    this.desktopPosition = this._toInt(this.getAttribute('data-d-grid'), 1)
    this.mobilePosition  = this._toInt(this.getAttribute('data-m-grid'), 1)

    const perEl = document.querySelector('[data-collection-per-page]')
    this.perPage = this._toInt(perEl?.getAttribute('data-collection-per-page'), 0)

    this.lastItemsCount = document.querySelectorAll('#product-grid .grid__item').length

    // bind
    this.updateHeroVarsBound = this.updateHeroVars.bind(this)

    // initial
    this.loadBlock()

    // re-run on collection reloads
    document.addEventListener('collection:reloaded', (e) => {
      const mobileGrid = this._toInt(this.getAttribute('data-m-grid'), 1)
      const count = this._toInt(e?.detail?.count, 0)
      if (count >= mobileGrid) this.loadBlock()
    })

    // infinite scroll
    document.addEventListener('ajaxinate.page:load', () => {
      const currentItemsCount = document.querySelectorAll('#product-grid .grid__item').length
      const isMobile = this._isMobile()
      if ((isMobile && this.mobilePosition > this.lastItemsCount && this.mobilePosition < currentItemsCount) ||
          (!isMobile && this.desktopPosition > this.lastItemsCount && this.desktopPosition < currentItemsCount)) {
        this.loadBlock()
      } else {
        this.updateHeroVars()
      }

      this._handlePaginationFocus()

      this.lastItemsCount = currentItemsCount
    })

    // keep synced across breakpoints
    this.mq = window.matchMedia('(max-width: 767px)')
    this.mq.addEventListener?.('change', this.updateHeroVarsBound)
    window.addEventListener('resize', this.updateHeroVarsBound)
  }

  disconnectedCallback() {
    this.mq?.removeEventListener?.('change', this.updateHeroVarsBound)
    window.removeEventListener('resize', this.updateHeroVarsBound)
  }

  //  Handle pagination focus
  _handlePaginationFocus() {
    const allItemsEls = document.querySelectorAll('#product-grid .grid__item')
    const firstNewItemEl = allItemsEls[this.lastItemsCount]

    if (allItemsEls.length <= this.lastItemsCount || !firstNewItemEl) return

    const newItemsCount = allItemsEls.length - this.lastItemsCount

    this._announcePaginationStatus(newItemsCount)
    this._focusOnNewItem(firstNewItemEl)
  }

  _announcePaginationStatus(count) {
    const statusEl = document.getElementById('PaginationStatus')
    if (!statusEl) return

    const productLabel = count === 1 ? 'product' : 'products'
    statusEl.textContent = `${count} more ${productLabel} loaded`
  }

  _focusOnNewItem(itemEl) {
    const focusableLinkEl = itemEl.querySelector('a')

    if (focusableLinkEl) {
      focusableLinkEl.focus()
      return
    }

    itemEl.setAttribute('tabindex', '-1')
    itemEl.focus()
  }

  /* --------------------------
     Fetch & insert
  ---------------------------*/
  loadBlock() {
    const sectionId   = this.sectionId
    const blockId     = this.id
    const desktopGrid = this.getAttribute('data-d-grid')
    const mobileGrid  = this.getAttribute('data-m-grid')
    const desktopCols = this.getAttribute('data-d-columns')
    const mobileCols  = this.getAttribute('data-m-columns')

    fetch(`${window.location.pathname}?section_id=${sectionId}`)
      .then((r) => r.text())
      .then((htmlText) => {
        const doc = new DOMParser().parseFromString(htmlText, 'text/html')
        const hero = doc.getElementById(blockId)
        this.insertDiv(hero, desktopGrid, mobileGrid, desktopCols, mobileCols)
        this.updateHeroVars()
      })
      .catch(console.error)
  }

  insertDiv(hero, desktopGrid, mobileGrid, desktopColumns, mobileColumns) {
    if (!hero) return

    // remove only THIS instance's hero
    document.getElementById(this.heroId)?.remove()

    const isMobile  = this._isMobile()
    const targetIdx = this._toInt(isMobile ? mobileGrid : desktopGrid, 1)
    const span      = this._toInt(isMobile ? mobileColumns : desktopColumns, 1)

    // find the reference item among PRODUCT tiles only (ignore any heroes)
    const gridContainer =
      document.querySelector('#product-grid') ||
      document.querySelector('#collection-product-grid') ||
      document.querySelector('.product-grid') ||
      document.querySelector('.grid')

    if (!gridContainer) return

    const productItems = Array.from(
      gridContainer.querySelectorAll('.grid__item')
    ).filter((el) => !el.classList.contains('grid-collection-hero'))

    // 1-based index: insert AFTER the target product tile
    const ref = productItems[targetIdx - 1]
    if (!ref) return

    // choose tag to match container semantics
    const wrapperTag = this._gridContainerIsList() ? 'li' : 'div'
    const div = document.createElement(wrapperTag)
    div.id = this.heroId                            // <-- unique id
    div.className = 'grid-collection-hero'
    div.innerHTML = hero.innerHTML

    // initial vars & helper classes
    const perRow = this.getGridPerRow(isMobile)
    div.style.setProperty('--per-row', String(perRow))
    div.style.setProperty('--span', String(span))
    div.classList.add('columns__' + span)
    div.classList.toggle('full', span >= perRow)

    // insert after the reference product tile
    ref.after(div)
  }

  /* --------------------------
     Vars refresh
  ---------------------------*/
  updateHeroVars() {
    const hero = document.getElementById(this.heroId)
    if (!hero) return
    const isMobile = this._isMobile()
    const perRow = this.getGridPerRow(isMobile)
    const span   = this.getSpan(isMobile)
    hero.style.setProperty('--per-row', String(perRow))
    hero.style.setProperty('--span', String(span))
    hero.classList.toggle('full', span >= perRow)
  }

  /* --------------------------
     Data sources
  ---------------------------*/
  getGridPerRow(isMobile) {
    const grid = document.querySelector('#collection-product-grid')
    const attr = isMobile
      ? (grid?.dataset?.mPerRow ?? grid?.getAttribute('data-m-per-row'))
      : (grid?.dataset?.dPerRow ?? grid?.getAttribute('data-d-per-row'))
    let perRow = this._toInt(attr, 0)

    if (!perRow && grid) {
      const cs = getComputedStyle(grid)
      if (cs.display.includes('grid') && cs.gridTemplateColumns && cs.gridTemplateColumns !== 'none') {
        perRow = Math.max(1, cs.gridTemplateColumns.trim().split(/\s+/).length)
      }
    }

    if (!perRow && grid) {
      const sample = grid.querySelector('.grid__item:not(.grid-collection-hero)')
      if (sample) {
        const r = sample.getBoundingClientRect()
        const csItem = getComputedStyle(sample)
        const outer = r.width + parseFloat(csItem.marginLeft || 0) + parseFloat(csItem.marginRight || 0)
        const gridWidth = grid.getBoundingClientRect().width
        if (outer > 0) perRow = Math.max(1, Math.round(gridWidth / outer))
      }
    }

    return perRow || (isMobile ? 2 : 4)
  }

  getSpan(isMobile) {
    const d = this._toInt(this.getAttribute('data-d-columns'), 1)
    const m = this._toInt(this.getAttribute('data-m-columns'), 1)
    return isMobile ? m : d
  }

  /* --------------------------
     Helpers
  ---------------------------*/
  _isMobile() {
    return window.matchMedia('(max-width: 767px)').matches
  }

  _gridContainerIsList() {
    const grid =
      document.querySelector('#product-grid') ||
      document.querySelector('#collection-product-grid') ||
      document.querySelector('.product-grid') ||
      document.querySelector('.grid')
    const tag = grid?.tagName?.toLowerCase()
    return tag === 'ul' || tag === 'ol'
  }

  _toInt(val, fallback) {
    const n = parseInt(val, 10)
    return Number.isFinite(n) && n > 0 ? n : fallback
  }
}

customElements.define('collection-hero', CollectionHero)

class ProductPreorder extends HTMLElement {
  #variantId = null
  #messageEl = null
  #dateEl = null
  #inputEl = null
  #submitButtonEl = null
  #submitButtonTextEl = null

  connectedCallback() {
    this.#messageEl = this.querySelector('.message')
    this.#dateEl = this.querySelector('.date')
    this.#inputEl = this.querySelector('input')
    this.#submitButtonEl = this.closest('product-form')?.querySelector('button[type="submit"][name="add"]')
    this.#submitButtonTextEl = this.#submitButtonEl?.querySelector('span')

    const initialVariantId = Number(this.dataset.variantId)
    if (!initialVariantId) return

    this.checkVariantPreorder(initialVariantId)
  }

  get preorderData() {
    return window.preorder[this.#variantId]
  }

  get isPreorderAvailable() {
    return Boolean(this.preorderData?.message)
  }

  checkVariantPreorder(id) {
    this.#variantId = id

    if (this.isPreorderAvailable) {
      this.show()
    } else {
      this.hide()
    }

    return this.isPreorderAvailable
  }

  show() {
    if (!this.isPreorderAvailable) return

    this.#messageEl.innerHTML = this.preorderData.message
    this.#dateEl.innerHTML = this.preorderData.date

    this.#inputEl.value = [this.preorderData.message, this.preorderData.date].filter(Boolean).join(' ')
    this.#inputEl.disabled = false

    if (this.#submitButtonEl) {
      this.#submitButtonEl.disabled = false
      this.#submitButtonTextEl.textContent = window.variantStrings.preOrder
    }

    this.classList.remove('hidden')
  }

  hide() {
    this.#messageEl.innerHTML = ''
    this.#dateEl.innerHTML = ''

    this.#inputEl.value = ''
    this.#inputEl.disabled = true

    this.classList.add('hidden')
  }
}

customElements.define('product-preorder', ProductPreorder)
